module.exports = __webpack_public_path__ + "img/app.qrcode.blue.f4cb6fbb.png";